export default {
  data () {
    return {
      elementVGamesBody: null,
      elementLeftMenu: null,
      elementSwitcher: null,
      elementAside: null,
      elementTopBettingHistory: null,
      elementBHBody: null,
      game: 'VSoccer'
    }
  },
  mounted () {
    this.elementVGamesBody = document.getElementById('VGamesBody')
    this.elementLeftMenu = document.getElementById('elementLeftMenu')
    setTimeout(() => {
      this.elementSwitcher = document.getElementById('switcher')
    }, 1000)
    this.elementAside = document.querySelector('.a-vg-aside--bet-placing')
    this.elementTopBettingHistory = document.querySelector('.a-vg-c--heading')
    this.elementBHBody = document.querySelector('.a-vg-c--body')
  }
}
